module.exports = {
	everad:[
		'kupiizdoma.ru',
		'orgsales.ru'
	],
	rocket: []
};


// WEBPACK FOOTER //
// ./frontend/shared/js/httpOnlyDomains.js